import React, { useEffect } from "react";
import { TOptions, TOptionValue } from "../optionsUtils";
import Checkbox from "../types/checkbox/Checkbox";
import Radio from "../types/radio/Radio";
import Toggle from "../types/toggle/Toggle";
import "./SmallOptionCard.scss";

interface IProps {
    id: string;
    type: TOptions;
    icon?: React.ReactNode;
    text?: string;
    value?: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function SmallOptionCard(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue>(props.value || "unselected");

    const onClick = (e) => {
        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <button
            id={props.id + "-small-ption-card"}
            onClick={onClick}
            className={`userful-small-opiton-card noselect ${
                value === "selected"
                    ? "userful-small-opiton-card-selected"
                    : value === "indeterminate"
                      ? "userful-small-opiton-card-indeterminate"
                      : ""
            } 
            ${props.disabled ? "userful-small-opiton-card-disabled" : ""}`}
        >
            <div className="userful-small-opiton-card-body">
                <div className="userful-small-opiton-card-icon">
                    {props.type === "checkbox" && (
                        <Checkbox value={value} onClick={onClick} disabled={props.disabled} />
                    )}
                    {props.type === "radio" && <Radio value={value} onClick={onClick} disabled={props.disabled} />}
                    {props.type === "toggle" && <Toggle value={value} onClick={onClick} disabled={props.disabled} />}
                </div>

                {props.icon && <div className="userful-small-opiton-card-image">{props.icon}</div>}

                {props.text && (
                    <div className="userful-small-opiton-card-text">
                        <h1> {props.text}</h1>
                    </div>
                )}
            </div>
        </button>
    );
}
